(function ($, window) {

	let win = $(window),
		cards;

	win.on("load", () => {

		cards = $('.card');
		if (cards.length < 1) return;

		// do on load
		cards.each(function () {
			cardsHeight($(this));
		});


		// execute once after screen resize
		win.on('resize.cardsHeight', $.debounce(250, function () {
			cards.each(function () {
				cardsHeight($(this));
			});
		}));

	});

	function cardsHeight(card) {

		if (win.outerWidth() >= 'NALU__BOOTSTRAP__BREAKPOINT__NALU') {

			let cardParent;

			cardParent = card.closest('.card-wrapper');
			if (cardParent.length < 1) return;

			let cardParentHeight = cardParent.innerHeight();

			let cardHeight = card.outerHeight();

			if (cardHeight < cardParentHeight) {
				// card.css({'height': cardParentHeight + 'px'});
				//card.find($('a')).css({'height': cardParentHeight + 'px'});
				//card.find($('.card-container')).css({'height': cardParentHeight + 'px'});
			}
		}

		// turn it off
		else {
			win.off('.cardsHeight');
		}

	}

})(jQuery, window);